// let comUrl = 'http://192.168.1.66:20001';
// let baseUrl = 'http://192.168.1.66:20002';
// let baseUrl = 'http://192.168.1.106:8080';

/* 本地测试地址 */
var isLocal = false;
var baseUrl;

if (isLocal) {
  baseUrl = 'http://192.168.1.9:8080' // 本地
  // baseUrl = 'https://192.168.1.147:8082' // 测试
} else {
  baseUrl = '' // 线上 -- 不要动
  // baseUrl = '/prod-api' // 线上 -- 本地调试打开这个
  // baseUrl = 'http://192.168.1.22:8080' // 本地

}

// var baseUrl = 'https://192.168.1.147:8082';
// var baseUrl = 'http://192.168.1.66:20001';

/* 线上地址 */
// let baseUrl = 'http://school.eceyun.net';
// let otherUrl = 'https://bdy.eceyun.net:8082';
// let baseUrl = 'https://bdy.kq.eceyun.net';
// let baseUrl = 'http://39.105.113.90:8080';


// export const bizURL=`${comUrl}/winwu-biz-web`;   //企业
export const bizURL = `${baseUrl}/winwu-biz-web`;   //企业
export const courseURL = `${baseUrl}/winwu-course-web`; //课程
export const examURL = `${baseUrl}/winwu-exam-web`; //考试
export const upmsURL = `${baseUrl}/winwu-upms-web`; //课程详情 练习列表

export const IsLocal = isLocal;
// export const IsKq = isKq;


